import type { Account } from '@alison/ui';
import { useQuery } from '@tanstack/react-query';
import { initialsFrom } from './format.js';
import { useTRPC } from './trpc.js';

export function useShellAccount(email: string | undefined): Account {
  const trpc = useTRPC();
  const { data } = useQuery(trpc.me.get.queryOptions());
  const name = email ?? '';
  const account: Account = { name, initials: initialsFrom(name) ?? '' };
  if (data?.organizationName) account.org = data.organizationName;
  return account;
}
